import React from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { path } from 'ramda';

import { ensureCurrentUser } from '../../util/data';
import config from '../../config';

const CriteoConfirmationBookingTagComponent = props => {
  const {
    currentUser,
    transactionId,
  } = props;
  const user = ensureCurrentUser(currentUser);
  const currentEmail = user.attributes.email;
  if (!currentEmail || !transactionId) return null;

  return (
    <div>
      <Helmet>
        <script type="text/javascript" src="https://static.criteo.net/js/ld/ld.js" async="true"/>
        <script type="text/javascript">
          {`
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            //function to return random number equal or greater to min and less than the max
            function getRandomInt(min, max) {
              min = Math.ceil(min);
              max = Math.floor(max);
              return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
            }
            window.criteo_q.push(
                    { event: "setAccount", account: ${config.criteoPartnerId} },
                    { event: "setEmail", email: "${currentEmail}" },
                    { event: "setSiteType", type: deviceType},
                    { event: "trackTransaction" , id: "${transactionId}", user_segment : 2,
            item: [
                          { id: getRandomInt(13,17)  , price: 1, quantity: 1 }
            ]});
         `}
        </script>
      </Helmet>
    </div>
  );
};

CriteoConfirmationBookingTagComponent.defaultProps = { listingId: null };

const mapStateToProps = state => ({
  currentUser: path(['user', 'currentUser'], state),
});

const CriteoConfirmationBookingTag = connect(mapStateToProps)(CriteoConfirmationBookingTagComponent);

export default CriteoConfirmationBookingTag;
